/**
 * Helper utilities for Select components to handle unmatched API values.
 * If an API value doesn't match any option in the dropdown list,
 * it will be shown as a disabled first option instead of being replaced.
 */

import { Option } from "../../../lib/api";

/**
 * Check if a value exists in the options list
 */
export const valueExistsInOptions = (value: string, options: Option[]): boolean => {
  if (!value || !options.length) return false;
  return options.some((o) => o.value === value);
};

/**
 * Get options for Select component and report whether the current value matches available options.
 * If the current value doesn't match any existing option, the selection should fall back to the placeholder.
 */
export const getSelectOptions = (
  currentValue: string | undefined,
  options: Option[]
): { options: Option[]; hasUnmatched: boolean } => {
  if (!currentValue || !currentValue.trim()) {
    return { options, hasUnmatched: false };
  }

  const valueMatches = valueExistsInOptions(currentValue, options);
  return { options, hasUnmatched: !valueMatches };
};
